<template>
  <div class="ucrs-stats">
    <Swiper :options="swiperOptions" navigation nav-position="aside">
      <div v-for="(item, i) in computedItems" :key="i" class="swiper-slide">
        <div class="ucrs-stats__item">
          <div
            class="ucrs-stats__inner"
            :style="`height: ${maxHeight}px; margin-top: ${tooltipHeight}px;`"
          >
            <div class="ucrs-stats__col" :style="`height: ${item.height}%`">
              <span class="ucrs-stats__tooltip">{{ item.qt }}%</span>
            </div>
          </div>
          <p class="ucrs-stats__label">{{ item.label }}</p>
        </div>
      </div>
    </Swiper>
  </div>
</template>

<script>
import Swiper from '~/components/Swiper.vue'

export default {
  components: {
    Swiper,
  },
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      },
    },
    maxHeight: {
      type: Number,
      default: 100,
    },
  },
  data() {
    return {
      tooltipHeight: 60,
      swiperOptions: {
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        watchOverflow: true,
        slidesPerView: 4,
        spaceBetween: 15,
        breakpoints: {
          768: {
            slidesPerView: 5,
            spaceBetween: 25,
          },
          1024: {
            slidesPerView: 6,
            spaceBetween: 25,
          },
        },
      },
    }
  },
  computed: {
    computedItems() {
      const computedItems = this.items
      const higher = Math.max.apply(
        Math,
        computedItems.map((el) => {
          return el.qt
        })
      )
      computedItems.forEach((el) => {
        el.height = (el.qt * 100) / higher
      })
      return computedItems
    },
  },
}
</script>

<style lang="postcss">
.ucrs-stats {
  &__inner {
    @apply flex flex-col justify-end;
  }

  &__col {
    @apply relative bg-blue-light border-t-2 border-blue;
  }

  &__tooltip {
    @apply absolute left-0 w-full bg-white text-blue text-lg font-bold rounded-md h-17 flex items-center justify-center text-center bottom-[calc(100%+16px)];

    &::after {
      @apply absolute top-full w-0 h-0 left-1/2 transform -translate-x-1/2 border-10 border-t-white border-r-transparent border-b-transparent border-l-transparent;

      content: '';
    }
  }

  &__label {
    @apply text-center font-bold text-sm mt-6;
  }
}
</style>
